import React, { useEffect, useRef, useState, useMemo } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Fieldset } from 'primereact/fieldset'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { FaBoxes, FaPhone } from 'react-icons/fa'

import {
  Badge,
  Btn,
  BtnIcon,
  CustomCheckbox,
  CustomDataTableHeader,
  CustomPanel,
  Loading,
  NumeroDecimal,
  PageHeader,
  ThreeDots,
  InputText,
  CustomMultiSelect,
  Periodo, // <-- adicionado
} from '../../../../components'
import { tableCellCentered } from '../../../../assets/js/styles'
import { showMessageBox } from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import * as RetornoHttp from '../../../../services/api/https/deliveries/retorno.http'
import { getDocumentosRotaMdfe } from '../../../../services/api/https/deliveries/mdfe.http'
import { menuItemsAllowed } from '../../../../services/permission/menus'
import { selectedFeetChanged } from '../../../../store/actions/retorno-veiculo.actions'
import * as colors from '../../../../assets/js/colors'
import ModalTelefone from './ModalTelefone'
import { gerarArquivoExcel } from '../../../../services/util/excel.service'
import {
  urlReportMapaDeCarga,
  urlReportMapaDeEntrega,
  urlReportMapaDeCargaAnalitico,
} from '../../../../services/api/routes/deliveries.routes'
import { formatDateToLocale } from '../../../../services/util/date.service'
import { useRetornoVeiculoContext } from '../../../../contexts/EntregaContext'
import { getPeriodoUltimos30Dias, parseToMysqlFormat } from '../../../../services/util/date.service'

const ESPERA_MAXIMA_DOCUMENTOS_MS = 1500

export const MENU_ITEMS = [
  '1. Geoposicionamento',
  '2. Bateria',
  '3. Chat',
  '4. Mapa de entrega',
  '5. Mapa de Carga - Analítico',
]

function RetornoVeiculo({ dispatch, selectedTp, history, notification }) {
  // Hooks
  const [isLoading, setIsLoading] = useState(true)
  const [frotas, setFrotas] = useState([])
  const [isBtnLoading, setIsBtnLoading] = useState(false)
  const [isSearching, setIsSearching] = useState(false)
  const [empresas, setEmpresas] = useState([])
  const abrindoRota = useRef(false)

  // Contexto dos filtros
  const { retornoVeiculoContext, setRetornoVeiculoContext } = useRetornoVeiculoContext()
  const [notaFiscal, setNotaFiscal] = useState(retornoVeiculoContext.notaFiscal || '')
  const [cidade, setCidade] = useState(retornoVeiculoContext.cidade || '')
  const [selectedEmpresas, setSelectedEmpresas] = useState(
    retornoVeiculoContext.selectedEmpresas || [],
  )

  // Estado para período (inicial e final) - carrega do contexto
  const [state, setState] = useState({
    periodo: retornoVeiculoContext.selectedPeriodo || getPeriodoUltimos30Dias(),
  })

  useEffect(() => {
    setRetornoVeiculoContext(prev => ({
      ...prev,
      selectedPeriodo: state.periodo,
      notaFiscal,
      cidade,
      selectedEmpresas,
    }))
  }, [state.periodo, notaFiscal, cidade, selectedEmpresas])

  useEffect(() => {
    _fetchVeiculosRetorno(state.periodo.dataInicial, state.periodo.dataFinal)
  }, [selectedTp])

  // ─── Filtro por empresas ───────────────────────────────────────────
  const filteredFrotas = useMemo(() => {
    if (!selectedEmpresas || selectedEmpresas.length === 0) return frotas
    const allowedCompanies = selectedEmpresas.map(e => e.name)
    return frotas.filter(
      frota =>
        frota.companies && frota.companies.some(company => allowedCompanies.includes(company)),
    )
  }, [frotas, selectedEmpresas])

  // ─── Extrair empresas únicas das frotas ───────────────────────────
  const extractUniqueCompanies = frotasData => {
    const allCompanies = []
    frotasData.forEach(frota => {
      if (frota.companies && Array.isArray(frota.companies)) {
        frota.companies.forEach(company => {
          if (!allCompanies.find(c => c.name === company)) {
            allCompanies.push({ name: company, id: company })
          }
        })
      }
    })
    return allCompanies.sort((a, b) => a.name.localeCompare(b.name))
  }

  // Event
  const onDataTableItemClicked = frota => {
    try {
      const index = filteredFrotas.findIndex(f => f.fleet_id === frota.fleet_id)
      if (index !== -1) {
        filteredFrotas[index].selected = filteredFrotas[index].selected
          ? !filteredFrotas[index].selected
          : true
        setFrotas([...frotas])
      }
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    }
  }

  const onSelecionarTodosClicked = () => {
    for (let index = 0; index < filteredFrotas.length; index++) {
      filteredFrotas[index].selected = filteredFrotas[index].selected
        ? !filteredFrotas[index].selected
        : true
    }
    setFrotas([...frotas])
  }

  const onBtnImportarApuracaoClicked = () => {
    history.push('/main/entregas/importa-apuracao')
  }

  const onBtnExportarExcelClick = async () => {
    const colunas = [
      [
        'placa',
        'nome_motorista',
        'cliente',
        'cidade',
        'cnpj',
        'nota_fiscal',
        'data_emissão_nfe',
        'qtde_caixas',
        'status',
        'data_status',
        'data_operacao',
        'chave_nf',
        'empresa',
        'fleet_id',
        'peso_total',
      ],
    ]

    const selectedFleetIds = filteredFrotas.filter(f => f.selected).map(f => f.fleet_id)

    if (selectedFleetIds.length === 0) {
      dispatch(showMessageBox(null, 'Nenhuma rota selecionada'))
      return
    }

    try {
      const exportFrotas = await RetornoHttp.getExportVeiculosParaRetorno(
        selectedTp,
        selectedFleetIds,
      )
      exportFrotas.forEach(e => {
        colunas.push([
          e.vehicle_badge,
          e.vehicle_driver,
          e.cliente,
          e.cidade,
          e.cnpj,
          e.nota_fiscal,
          e.issuance_date,
          e.qte_volumes,
          e.status,
          e.data_status,
          e.data_operacao,
          e.chave_nf,
          e.company_name,
          e.fleet_id,
          e.weight,
        ])
      })
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    }

    gerarArquivoExcel('frotas', colunas, 'apuracao_de_retorno.xlsx')
  }

  const onBtnEntregaTotalClicked = async () => {
    try {
      const selectedFrotas = filteredFrotas.filter(f => f.selected)
      if (selectedFrotas.length === 0) {
        throw new Error('Selecione ao menos UM veículo')
      }

      const invalidFrotas = selectedFrotas.filter(f => f.acess_to_all_companies === false)
      if (invalidFrotas.length > 0) {
        const labels = invalidFrotas.map(f => f.fleet_id).join(' , ')
        dispatch(
          showMessageBox(
            null,
            `Não é possível concluir a entrega pois o usuário não tem acesso à todas as empresas associadas a(s) rota(s): ${labels}`,
          ),
        )
        return
      }

      setIsBtnLoading(true)
      const fleets_ids = selectedFrotas.map(f => f.fleet_id)
      await RetornoHttp.postVeiculosComEntregaTotal(selectedTp, fleets_ids)

      const nFrotas = []
      frotas.forEach(f => {
        const nFleet = fleets_ids.find(id => id === f.fleet_id)
        if (!nFleet) nFrotas.push(f)
      })
      setFrotas(nFrotas)

      dispatch(showMessageBox('Entregas Total realizadas com sucesso!', null))
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    } finally {
      setIsBtnLoading(false)
    }
  }

  const onDeliveriesIconClicked = async frota => {
    if (frota.acess_to_all_companies === false) {
      dispatch(
        showMessageBox(null, 'Usuário não tem acesso a todas as empresas associadas ao veículo'),
      )
      return
    }
    if (abrindoRota.current) return
    abrindoRota.current = true

    // Consulta antes de abrir para o botão do MDFe já vir certo; se demorar, a tela abre e consulta de novo
    const podeGerirMdfe =
      menuItemsAllowed([{ id: 40, content: "3.18 - Gestão de CTe's" }]).length > 0
    const documentosRota = podeGerirMdfe
      ? await Promise.race([
          getDocumentosRotaMdfe(frota.fleet_id).catch(() => null),
          new Promise(resolve => setTimeout(() => resolve(null), ESPERA_MAXIMA_DOCUMENTOS_MS)),
        ])
      : null
    abrindoRota.current = false

    dispatch(selectedFeetChanged(frota))
    history.push('/main/entregas/retorno-veiculo-apuracao', {
      fleet_id: frota.fleet_id,
      vehicle_badge: frota.vehicle_badge,
      driver_id: frota.driver_id,
      driver_tp_id: frota.driver_tp_id,
      expected_date: formatDateToLocale(frota.expected_date, 'dd/MM/yyyy').toISO(),
      documentos_rota: documentosRota,
    })
  }

  const onBtnEmitirMapaClick = fleetsSelected => {
    if (!Array.isArray(fleetsSelected) || fleetsSelected.length === 0) {
      dispatch(showMessageBox(null, 'Nenhuma placa foi selecionada'))
    } else {
      const invalidFrotas = fleetsSelected.filter(f => f.acess_to_all_companies === false)
      if (invalidFrotas.length > 0) {
        const labels = invalidFrotas.map(f => f.fleet_id).join(' , ')
        dispatch(
          showMessageBox(
            null,
            `Não é possível gerar o relatório pois o usuário não tem acesso à todas as empresas associadas a(s) rota(s): ${labels}`,
          ),
        )
        return
      }
      const url = urlReportMapaDeCarga(selectedTp, fleetsSelected.map(f => f.fleet_id).join(','))
      window.open(url, '_blank')
    }
  }

  const onBtnEmitirMapaEntregaClick = fleetsSelected => {
    if (!Array.isArray(fleetsSelected) || fleetsSelected.length === 0) {
      dispatch(showMessageBox(null, 'Nenhuma placa foi selecionada'))
    } else {
      const invalidFrotas = fleetsSelected.filter(f => f.acess_to_all_companies === false)
      if (invalidFrotas.length > 0) {
        const labels = invalidFrotas.map(f => f.fleet_id).join(' , ')
        dispatch(
          showMessageBox(
            null,
            `Não é possível gerar o relatório pois o usuário não tem acesso à todas as empresas associadas a(s) rota(s): ${labels}`,
          ),
        )
        return
      }
      const url = urlReportMapaDeEntrega(selectedTp, fleetsSelected.map(f => f.fleet_id).join(','))
      window.open(url, '_blank')
    }
  }

  const onMenuItemClicked = (item, frota) => {
    switch (item) {
      case '1. Geoposicionamento':
        history.push('/main/entregas/geoposicionamento', {
          fleet_id: frota.fleet_id,
          vehicle_badge: frota.vehicle_badge,
        })
        break
      case '2. Bateria':
        history.push('/main/entregas/bateria-celular', {
          fleet_id: frota.fleet_id,
          vehicle_badge: frota.vehicle_badge,
        })
        break
      case '3. Chat':
        history.push('/main/entregas/chat', {
          fleet_id: frota.fleet_id,
          vehicle_badge: frota.vehicle_badge,
          tp_id: selectedTp,
          driver_id: frota.driver_id,
          expected_date: formatDateToLocale(frota.expected_date, 'dd/MM/yyyy').toISO(),
        })
        break
      case '4. Mapa de entrega':
        if (frota.acess_to_all_companies === false) {
          dispatch(
            showMessageBox(
              null,
              'Usuário não tem acesso a todas as empresas associadas ao veículo',
            ),
          )
          return
        }
        const urlMapaEntrega = urlReportMapaDeEntrega(selectedTp, frota.fleet_id)
        window.open(urlMapaEntrega, '_blank')
        break
      case '5. Mapa de Carga - Analítico':
        if (frota.acess_to_all_companies === false) {
          dispatch(
            showMessageBox(
              null,
              'Usuário não tem acesso a todas as empresas associadas ao veículo',
            ),
          )
          return
        }
        const urlMapaAnalitico = urlReportMapaDeCargaAnalitico(selectedTp, frota.fleet_id)
        window.open(urlMapaAnalitico, '_blank')
        break
      default:
        break
    }
  }

  // Helper
  const _fetchVeiculosRetorno = async (
    pInicial = state.periodo.dataInicial,
    pFinal = state.periodo.dataFinal,
  ) => {
    try {
      const fetchedFrotas = await RetornoHttp.getVeiculosParaRetorno(
        selectedTp,
        parseToMysqlFormat(pInicial),
        parseToMysqlFormat(pFinal),
      )

      setFrotas(fetchedFrotas)
      // ─── Extrair empresas únicas ───────────────────────────────────────────
      const uniqueCompanies = extractUniqueCompanies(fetchedFrotas)
      setEmpresas(uniqueCompanies)
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    } finally {
      setIsLoading(false)
    }
  }

  // ─── Busca filtrada por Nota Fiscal ───────────────────────────
  const buscarPorNotaFiscal = async () => {
    // 1) validações
    if (!selectedTp) {
      dispatch(showMessageBox(null, errorHandler(new Error('Selecione um TP antes de buscar'))))
      return
    }
    if (!notaFiscal.trim()) {
      dispatch(showMessageBox(null, errorHandler(new Error('Digite a Nota Fiscal para buscar'))))
      return
    }

    setIsSearching(true)
    try {
      const result = await RetornoHttp.getVeiculosParaRetornoByNF(
        selectedTp,
        notaFiscal.trim(),
        parseToMysqlFormat(state.periodo.dataInicial),
        parseToMysqlFormat(state.periodo.dataFinal),
      )
      setFrotas(result)
      const uniqueCompanies = extractUniqueCompanies(result)
      setEmpresas(uniqueCompanies)
    } catch (err) {
      dispatch(showMessageBox(null, errorHandler(err)))
    } finally {
      setIsSearching(false)
    }
  }

  // ─── Busca filtrada por Cidade ───────────────────────────
  const buscarPorCidade = async () => {
    // 1) validações
    if (!selectedTp) {
      dispatch(showMessageBox(null, errorHandler(new Error('Selecione um TP antes de buscar'))))
      return
    }
    if (!cidade.trim()) {
      dispatch(showMessageBox(null, errorHandler(new Error('Digite a Cidade para buscar'))))
      return
    }

    setIsSearching(true)
    try {
      const result = await RetornoHttp.getVeiculosParaRetornoByCidade(
        selectedTp,
        cidade.trim(),
        parseToMysqlFormat(state.periodo.dataInicial),
        parseToMysqlFormat(state.periodo.dataFinal),
      )
      setFrotas(result)
      const uniqueCompanies = extractUniqueCompanies(result)
      setEmpresas(uniqueCompanies)
    } catch (err) {
      dispatch(showMessageBox(null, errorHandler(err)))
    } finally {
      setIsSearching(false)
    }
  }
  // ───────────────────────────────────────────────────────────────

  // Render
  return (
    <React.Fragment>
      <PageHeader>3.8 - Retorno do Veículo de Entrega para Rota</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          {isLoading ? (
            <div>
              <Loading size="md" />
            </div>
          ) : (
            <React.Fragment>
              <div className="p-col-3">
                <label style={{ fontWeight: 'bold', display: 'block', marginBottom: 4 }}>
                    Data de Envio para Rota:
                 </label>
                <Periodo
                  periodoInicial={state.periodo.dataInicial}
                  periodoFinal={state.periodo.dataFinal}
                  onPesquisar={(pInicial, pFinal) => {
                    setIsLoading(true)
                    setState(prev => ({
                      ...prev,
                      periodo: { dataInicial: pInicial, dataFinal: pFinal },
                    }))
                    _fetchVeiculosRetorno(pInicial, pFinal)
                  }}
                />
              </div>
              <FormComponent
                onSelecionarTodosClicked={onSelecionarTodosClicked}
                isBtnLoading={isBtnLoading}
                onBtnEntregaTotalClicked={onBtnEntregaTotalClicked}
                onBtnImportarApuracaoClicked={onBtnImportarApuracaoClicked}
                onBtnExportarExcel={onBtnExportarExcelClick}
                frotas={filteredFrotas}
                onBtnEmitirMapaClick={onBtnEmitirMapaClick}
                onBtnEmitirMapaEntregaClick={onBtnEmitirMapaEntregaClick}
              />
              <div style={{ marginTop: 20 }}>
                <Fieldset legend="Filtro" toggleable collapsed={true}>
                  <div className="p-grid p-align-center">
                    <div className="p-col-4">
                      <InputText
                        label="Nota Fiscal"
                        value={notaFiscal}
                        onChange={value => setNotaFiscal(value)}
                      />
                    </div>
                    <div className="p-col-2" style={{ marginTop: 32 }}>
                      <Btn isLoading={isSearching} onClick={buscarPorNotaFiscal}>
                        Buscar
                      </Btn>
                    </div>
                    <div className="p-col-4">
                      <InputText
                        label="Cidade"
                        value={cidade}
                        onChange={value => setCidade(value)}
                      />
                    </div>
                    <div className="p-col-2" style={{ marginTop: 32 }}>
                      <Btn isLoading={isSearching} onClick={buscarPorCidade}>
                        Buscar
                      </Btn>
                    </div>
                  </div>
                  <div className="p-grid p-align-center" style={{ marginTop: 10 }}>
                    <div className="p-col-4">
                      <CustomMultiSelect
                        disabled={empresas.length === 0}
                        placeholder="Selecione as empresas"
                        optionLabel="name"
                        options={empresas}
                        label="Empresas"
                        onChange={value => setSelectedEmpresas(value)}
                        value={selectedEmpresas}
                      />
                    </div>
                  </div>
                </Fieldset>
              </div>
              <DataTableComponent
                frotas={filteredFrotas}
                onItemClicked={onDataTableItemClicked}
                onIconClicked={onDeliveriesIconClicked}
                onMenuItemClicked={onMenuItemClicked}
                notification={notification}
              />
            </React.Fragment>
          )}
        </CustomPanel>
      </div>
    </React.Fragment>
  )
}

function FormComponent({
  onSelecionarTodosClicked,
  isBtnLoading,
  onBtnEntregaTotalClicked,
  onBtnImportarApuracaoClicked,
  onBtnExportarExcel,
  frotas,
  onBtnEmitirMapaClick,
  onBtnEmitirMapaEntregaClick,
}) {
  // Hooks
  const [selecionarTodos, setSelecionarTodos] = useState(false)
  const [disableEntregaTotal, setDisableEntregaTotal] = useState(false)

  useEffect(() => {
    frotas.length && frotas.filter(f => f.selected).find(f => f.qte_faltas)
      ? setDisableEntregaTotal(true)
      : setDisableEntregaTotal(false)
  }, [frotas])
  // Events
  const onChkTodosClicked = value => {
    setSelecionarTodos(value)
    onSelecionarTodosClicked(value)
  }

  // Render
  return (
    <Fieldset legend="Selecione os Veículos para Apuração do Retorno">
      <div className="p-grid">
        <div className="p-col-4">
          <CustomCheckbox checked={selecionarTodos} onChange={onChkTodosClicked}>
            Selecionar Todos
          </CustomCheckbox>
        </div>
        <div style={{ display: 'inline-block', marginLeft: 10 }}>
          <Btn
            isLoading={isBtnLoading}
            onClick={onBtnEntregaTotalClicked}
            disabled={disableEntregaTotal}
          >
            Entrega Total
          </Btn>
        </div>
        <div style={{ display: 'inline-block', marginLeft: 10 }}>
          <Btn onClick={() => onBtnImportarApuracaoClicked()}>Importar Apuração</Btn>
        </div>
        <div style={{ display: 'inline-block', marginLeft: 10 }}>
          <Btn onClick={() => onBtnExportarExcel()}>Exportar Excel</Btn>
        </div>
        <div style={{ display: 'inline-block', marginLeft: 10 }}>
          <Btn onClick={() => onBtnEmitirMapaClick(frotas.filter(f => f.selected))}>
            Emitir Mapa de Carga
          </Btn>
        </div>
        <div style={{ display: 'inline-block', marginLeft: 10 }}>
          <Btn onClick={() => onBtnEmitirMapaEntregaClick(frotas.filter(f => f.selected))}>
            Emitir Mapa de Entrega
          </Btn>
        </div>
      </div>
    </Fieldset>
  )
}

function DataTableComponent({
  frotas,
  onItemClicked,
  onIconClicked,
  onMenuItemClicked,
  notification,
}) {
  const [globalFilter, setGlobalFilter] = useState('')
  const [modalTelefone, setModalTelefone] = useState({ show: false, data: null })

  // Events
  console.log(notification)
  // Render
  return (
    <div style={{ marginTop: 20 }}>
      <DataTable
        value={frotas}
        header={<CustomDataTableHeader onChange={setGlobalFilter} />}
        globalFilter={globalFilter}
        emptyMessage="Não existe veículo para realização de Retorno"
        paginator={true}
        rows={10}
      >
        <Column
          header="#"
          style={tableCellCentered(80)}
          body={frota => (
            <CustomCheckbox checked={frota.selected} onChange={() => onItemClicked(frota)} />
          )}
        />
        <Column field="fleet_id" header="Rota" style={tableCellCentered(80)} />
        <Column field={'expected_date'} header="Data Prevista" style={tableCellCentered(130)} />
        <Column field={'sent_time'} header="Data Envio" style={tableCellCentered()} />
        <Column className="text-center" field="vehicle_badge" header="Placa" />
        <Column className="text-center" field="vehicle_driver" header="Motorista" />
        <Column className="text-center" field="driver_assistant_name" header="Ajudante" />
        <Column style={tableCellCentered(130)} field="qte_deliveries" header="Qte. Identif." />
        <Column
          style={tableCellCentered(130)}
          header="Possui Falta"
          body={frota =>
            frota.qte_faltas ? (
              <Badge color={colors.vinho}>sim</Badge>
            ) : (
              <Badge color={colors.verde}>não</Badge>
            )
          }
        />
        <Column style={tableCellCentered()} field="qte_sku" header="Qte. Caixas" />
        <Column
          style={tableCellCentered()}
          field="weight"
          header="Peso Total"
          body={item => <NumeroDecimal>{item.weight}</NumeroDecimal>}
        />
        <Column
          header=""
          style={tableCellCentered(60)}
          body={frota => (
            <div>
              {notification.deliveries_ids.some(id => frota.deliveries.includes(id)) && (
                <span
                  style={{
                    position: 'absolute',
                    width: '10px',
                    height: '10px',
                    backgroundColor: '#14b0bf',
                    borderRadius: '50%',
                    marginLeft: '20px',
                  }}
                />
              )}
              <BtnIcon onClick={() => onIconClicked(frota)}>
                <FaBoxes color="#3ac2bb" size={18} />
              </BtnIcon>
              {frota.driver_phone && (
                <>
                  <BtnIcon
                    onClick={() => {
                      setModalTelefone({ show: true, data: frota })
                    }}
                  >
                    <FaPhone color="#3ac2bb" size={18} />
                  </BtnIcon>
                  <ModalTelefone
                    show={modalTelefone.show}
                    data={modalTelefone.data}
                    onModalClose={() => {
                      setModalTelefone({ show: false, data: null })
                    }}
                  />
                </>
              )}
            </div>
          )}
        />
        <Column
          header="Menu"
          style={tableCellCentered(70)}
          body={frota => (
            <div>
              {notification.fleets_ids.includes(frota.fleet_id) && (
                <span
                  style={{
                    position: 'absolute',
                    width: '10px',
                    height: '10px',
                    backgroundColor: '#14b0bf',
                    borderRadius: '50%',
                    marginLeft: '10px',
                  }}
                />
              )}
              <ThreeDots items={MENU_ITEMS} onClick={item => onMenuItemClicked(item, frota)} />
            </div>
          )}
          bodyStyle={tableCellCentered()}
        />
      </DataTable>
    </div>
  )
}

const mapToProps = ({ system: { selectedTp }, notification }) => ({
  selectedTp,
  notification,
})
export default connect(mapToProps)(withRouter(RetornoVeiculo))
